import { Routes } from '~/enums/Routes'

export const CheckoutRoutes = Object.freeze([
  Routes.Checkout.Shipping,
  Routes.Checkout.ShippingSlug,
  Routes.Checkout.Payment,
  Routes.Checkout.PaymentSlug,
  Routes.Checkout.Confirm,
  Routes.Checkout.ConfirmSlug,
])
